// extracted by mini-css-extract-plugin
module.exports =  {"content":"e3afc254ff--content--X8YLC","border":"e3afc254ff--border--mKc0n"};